function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M179.856,91.57h2.27l3.46,6.021h.143l3.459-6.021h2.271l-4.805,8.045v5.2h-1.992v-5.2Z",
  transform: "translate(-179.856 -91.389)",
  fill: "#2cbbdb"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M208.325,98.195a7.936,7.936,0,0,1-.776,3.646,5.673,5.673,0,0,1-2.125,2.34,6.149,6.149,0,0,1-6.131,0,5.676,5.676,0,0,1-2.125-2.343,8.939,8.939,0,0,1,0-7.286,5.676,5.676,0,0,1,2.125-2.341,6.149,6.149,0,0,1,6.131,0,5.669,5.669,0,0,1,2.125,2.341A7.93,7.93,0,0,1,208.325,98.195Zm-1.979,0a6.389,6.389,0,0,0-.52-2.725,3.872,3.872,0,0,0-1.423-1.682,3.922,3.922,0,0,0-4.085,0,3.873,3.873,0,0,0-1.42,1.682,7.388,7.388,0,0,0,0,5.451,3.876,3.876,0,0,0,1.42,1.683,3.934,3.934,0,0,0,4.085,0,3.875,3.875,0,0,0,1.423-1.683A6.387,6.387,0,0,0,206.345,98.195Z",
  transform: "translate(-179.66 -91.391)",
  fill: "#2cbbdb"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M223.46,91.57h2v8.713a4.619,4.619,0,0,1-.653,2.46,4.531,4.531,0,0,1-1.838,1.682,6.58,6.58,0,0,1-5.543,0,4.532,4.532,0,0,1-1.835-1.682,4.619,4.619,0,0,1-.654-2.46V91.57h2v8.55a3.17,3.17,0,0,0,.4,1.6,2.815,2.815,0,0,0,1.128,1.1,3.989,3.989,0,0,0,3.477,0,2.763,2.763,0,0,0,1.125-1.1,3.209,3.209,0,0,0,.392-1.6Z",
  transform: "translate(-179.441 -91.389)",
  fill: "#2cbbdb"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M232.52,104.816V91.57h4.721a5.5,5.5,0,0,1,2.558.531,3.519,3.519,0,0,1,1.523,1.464,4.463,4.463,0,0,1,.5,2.157,4.348,4.348,0,0,1-.508,2.137,3.455,3.455,0,0,1-1.526,1.433,5.678,5.678,0,0,1-2.558.511h-3.577v-1.72h3.4a3.85,3.85,0,0,0,1.581-.278,1.848,1.848,0,0,0,.9-.808,2.665,2.665,0,0,0,.284-1.274,2.764,2.764,0,0,0-.288-1.3,1.911,1.911,0,0,0-.9-.844,3.71,3.71,0,0,0-1.6-.294h-2.509v11.532Zm6.539-5.976,3.272,5.976h-2.277l-3.208-5.976Z",
  transform: "translate(-179.232 -91.389)",
  fill: "#2cbbdb"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M259.668,104.816l-3.79-13.246h3.059l2.193,9.2h.11l2.418-9.2h2.62l2.413,9.223h.116L271,91.57h3.06l-3.79,13.246h-2.729l-2.523-8.66h-.1l-2.516,8.66Z",
  transform: "translate(-255.878 -91.389)",
  fill: "#2cbbdb"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M291.064,98.195a7.674,7.674,0,0,1-.819,3.687,5.707,5.707,0,0,1-2.224,2.319,6.66,6.66,0,0,1-6.329,0,5.729,5.729,0,0,1-2.219-2.322,8.734,8.734,0,0,1,0-7.366,5.7,5.7,0,0,1,2.219-2.319,6.664,6.664,0,0,1,6.329,0,5.7,5.7,0,0,1,2.224,2.319A7.666,7.666,0,0,1,291.064,98.195Zm-2.839,0a5.955,5.955,0,0,0-.417-2.367,3.225,3.225,0,0,0-1.174-1.461,3.4,3.4,0,0,0-3.544,0,3.213,3.213,0,0,0-1.174,1.461,6.914,6.914,0,0,0,0,4.734,3.212,3.212,0,0,0,1.174,1.461,3.4,3.4,0,0,0,3.544,0,3.225,3.225,0,0,0,1.174-1.461A5.957,5.957,0,0,0,288.225,98.195Z",
  transform: "translate(-255.608 -91.391)",
  fill: "#2cbbdb"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M304.457,95.382a1.636,1.636,0,0,0-.666-1.215,2.638,2.638,0,0,0-1.6-.434,3.114,3.114,0,0,0-1.158.19,1.627,1.627,0,0,0-.72.528,1.246,1.246,0,0,0-.25.763,1.075,1.075,0,0,0,.153.62,1.487,1.487,0,0,0,.456.456,3.2,3.2,0,0,0,.672.33,6.713,6.713,0,0,0,.816.237l1.19.284a8.327,8.327,0,0,1,1.591.517,4.853,4.853,0,0,1,1.256.8,3.336,3.336,0,0,1,.824,1.113,3.537,3.537,0,0,1,.3,1.468,3.652,3.652,0,0,1-.617,2.1,3.934,3.934,0,0,1-1.759,1.378,7.066,7.066,0,0,1-2.765.489,7.266,7.266,0,0,1-2.792-.493,4.061,4.061,0,0,1-1.85-1.458,4.329,4.329,0,0,1-.7-2.4h2.711a1.992,1.992,0,0,0,.384,1.109,2.073,2.073,0,0,0,.912.667,3.552,3.552,0,0,0,1.3.223,3.364,3.364,0,0,0,1.239-.207,1.9,1.9,0,0,0,.819-.575,1.336,1.336,0,0,0,.29-.848,1.11,1.11,0,0,0-.261-.75,2.051,2.051,0,0,0-.764-.518,7.838,7.838,0,0,0-1.225-.388L300.8,99.01a6.049,6.049,0,0,1-2.645-1.274,2.955,2.955,0,0,1-.963-2.335,3.454,3.454,0,0,1,.644-2.1,4.3,4.3,0,0,1,1.788-1.4,6.329,6.329,0,0,1,2.587-.5,6.151,6.151,0,0,1,2.577.5,4.089,4.089,0,0,1,1.717,1.4,3.715,3.715,0,0,1,.634,2.082Z",
  transform: "translate(-255.393 -91.391)",
  fill: "#2cbbdb"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M313.355,104.816V91.57h2.8v5.466h5.685V91.57h2.795v13.246H321.84V99.345h-5.685v5.471Z",
  transform: "translate(-255.197 -91.389)",
  fill: "#2cbbdb"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 146.36,
    height: 13.648,
    viewBox: "0 0 146.36 13.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-179.856 -91.391)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(179.856 91.391)",
    style: {
      isolation: "isolate"
    }
  }, _ref2, _ref3, _ref4, _ref5), /*#__PURE__*/React.createElement("g", {
    transform: "translate(256.778 91.391)",
    style: {
      isolation: "isolate"
    }
  }, _ref6, _ref7, _ref8, _ref9)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.04474ae080f9f102e04348f8b0ec99cc.svg";
export { ForwardRef as ReactComponent };